import { render, staticRenderFns } from "./ConfigPrice.vue?vue&type=template&id=1d4b5bbd"
import script from "./ConfigPrice.vue?vue&type=script&lang=js"
export * from "./ConfigPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports